<template>
<main class="SectionProfile-MAIN">
    <img src="../assets/arrow-back.png" @click="goBack()"/>
    
    <!-- main -->
    <section class="profile-main" v-if="view == 'profile'">
        <div>
            <img :src="`${this.$ENDPOINT}/assets/pfp/${form.profilepic}`"/>
            <div>
                <h2>{{ userData.name }}</h2>
                <button @click="view = 'edit'">Editar perfil</button>
            </div>
        </div>
        <h2>Guardado</h2>
        <hr/>
        <div class="saved-filters">
            <button @click="filter = 'todos'" :class="{ 'btn-filter-selected': filter == 'todos' }">Todos</button>
            <button @click="filter = 'piezas'" :class="{ 'btn-filter-selected': filter == 'piezas' }">Piezas</button>
            <button @click="filter = 'artistas'" :class="{ 'btn-filter-selected': filter == 'artistas' }">Artistas</button>
            <button @click="filter = 'publicaciones'" :class="{ 'btn-filter-selected': filter == 'publicaciones' }">Publicaciones</button>
        </div>
        <div class="saved-options">
            <div>{{ lists.length }} Listas</div>
            <div @click="openNewList()">+ Nueva</div>
        </div>
        <div class="profile-collections">
            <p v-if="loadingLists">Cargando listas...</p>
            <p v-else-if="!lists.length">Aún no tienes listas.</p>
            <div class="collection" v-for="list in lists" :key="list.id" @click="deployList(list.id)">
                <div>
                    <img 
                        v-for="(image, index) in getListPreviewImages(list)" 
                        :key="`img-${index}`"
                        :src="image"
                        :style="{ gridArea: ['A', 'B', 'C'][index] }"
                    />

                    <div 
                        v-for="(area, index) in getEmptyPreviewAreas(list)"
                        :key="`empty-${index}`"
                        class="empty-preview"
                        :style="{ gridArea: area }"
                    ></div>
                </div>
                <p>{{ list.name }}</p>
                <p>{{ list.total_items || 0 }} piezas</p>
            </div>
        </div>
    </section>

    <!-- edit -->
    <section class="profile-edit" v-if="view == 'edit'">
        <div>
            <h3>Editar perfil</h3>
            <img 
                v-if="form.profilepicPreview"
                :src="form.profilepicPreview"
            />
            <img 
                v-else-if="form.profilepic"
                :src="`${this.$ENDPOINT}/assets/pfp/${form.profilepic}`"
            />
            <button type="button" @click="$refs.profilepicInput.click()">
                Cambiar imagen
            </button>
            <input 
                ref="profilepicInput"
                type="file"
                accept="image/png,image/jpeg,image/webp"
                hidden
                @change="onProfilePicChange"
                :disabled="loading"
            />
        </div>

        <b>Nombre:</b>
        <input type="text" placeholder="" v-model="form.name" :disabled="loading"/>
        <b>Profesión:</b>
        <input type="text" placeholder="" v-model="form.profession" :disabled="loading"/>
        <b>Instagram:</b>
        <input type="text" placeholder="@" v-model="form.instagram" :disabled="loading"/>

        <p class="p-actions" @click="view = 'changeEmail'">Cambiar dirección de correo</p>
        <p class="p-actions" @click="view = 'changePass'">Cambiar contraseña</p>
        <p class="p-actions" @click="view = 'deactivate'">Desactivar cuenta</p>
        <p class="p-actions" @click="view = 'newsletter'">Cambiar suscripción a newsletter</p>
        <p class="p-actions p-close-session" @click="logOut()">Cerrar sesión</p>

        <button @click="saveProfile()" :disabled="loading">{{ loading ? 'SUBIENDO...' : 'GUARDAR' }}</button>
    </section>

    <!-- list -->
    <section class="profile-list" v-if="newList.active">
        <div class="close-list" @click="closeNewList()"></div>
        <div>
            <b>Nueva lista:</b>
            <input 
                type="text" 
                placeholder="Nombra tu lista" 
                :class="{ 'input-list-error': newList.error }" 
                v-model="newList.name" 
                @keyup.enter="createList"
            />
            <p v-if="newList.error">{{ newList.error }}</p>
            <button @click="createList()">Crear lista</button>
        </div>
    </section>

    <!-- changeEmail -->
    <section class="profile-change-email" v-if="view == 'changeEmail'">
        <h3>Dirección de correo</h3>

        <b>Email</b>
        <input type="email" placeholder="nombre@ejemplo.com"/>

        <button @click="changeEmail()">Guardar</button>
    </section>

    <!-- changePass -->
    <section class="profile-change-pass" v-if="view == 'changePass'">
        <h3>Cambiar contraseña</h3>

        <b>Contraseña actual</b>
        <input type="password" placeholder="********" v-model="changePassForm.current"/>
        
        <br/><br/><br/><br/>

        <b>Nueva contraseña</b>
        <input type="password" placeholder="********" v-model="changePassForm.confirm"/>

        <b>Confirmar</b>
        <input type="password" placeholder="********" v-model="changePassForm.new"/>

        <p v-if="errorMsgPass" class="error-msg">{{ errorMsgPass }}</p>
        <p v-if="okLogPass" class="ok-log">{{ okLogPass }}</p>

        <button @click="changePass()">Guardar</button>
    </section>

    <!-- deactivate -->
    <section class="profile-deactivate" v-if="view == 'deactivate'">
        <h3>Desactivar cuenta</h3>

        <p>
            Al desactivar, tu presencia en la plataforma será suspendida.
            Todo tu contenido será ocultado.
            Podrás reactivar tu sesión cuando lo desees.
        </p>

        <b>Contraseña</b>
        <input type="password" placeholder="********"/>

        <button @click="deactivate()">Desactivar</button>
        <button class="profile-cancel-dectivate" @click="goBack()">Cancelar</button>
    </section>

    <section class="profile-edit-newsletter" v-if="view == 'newsletter'">
        <h3>Cambiar suscripción a newsletter</h3>
        <p>
            Las novedades del newsletter llegarán al correo asociado a esta cuenta:
            <br><strong>{{ userData.email }}</strong>
        </p>
        <br/>
        <div class="switch">
            <label class="news-switch">
                <input type="checkbox" v-model="newsletterActive" @change="toggleNewsletter"/>
                <div></div>
            </label>
            Newsletter {{ newsletterActive ? '' : 'in' }}activo
        </div>
    </section>

    <!-- deploy list -->
    <section class="deploy-list" v-if="view == 'list'">
        <h2>{{ listDeployed?.list?.name }}</h2>
        <p class="list-description" v-if="listDeployed?.list?.description">{{ listDeployed?.list?.description }}</p>
        <hr/>
        <div class="list-item-grid">
            <div class="list-item" v-for="(item, index) in listDeployed?.list?.items" :key="index">
                <div class="list-item-img" @click="$router.push({ name: 'artworkcard', params: { id: String(item.data.id) }, query: { from: 'profile' }  });">
                    <img :src="`${this.$ENDPOINT}/assets/artworks/${item.data.file}`"/>
                    <p>{{ item.data.title }}</p>
                </div>
            </div>
        </div>
    </section>
        
</main>
</template>

<script>
export default {
    name: 'SectionProfile',
    data(){
        return{
            userData: JSON.parse(localStorage.getItem('userData') || '[]'),
            filter: 'todos', // 'todos' | 'piezas' | 'artistas' | 'publicaciobes'
            view: 'profile', // 'profile' | 'edit' | 'changeEmail' | 'changePass' | 'deactivate' | 'list'
            form: {
                name: '',
                profession: '',
                instagram: '',
                profilepic: '',
            },
            selectedProfilePicFile: null,
            newList: {
                active: false,
                name: '',
                error: false,
            },
            changeEmailForm: '',
            changePassForm: {
                current: '',
                new: '',
                confirm: '',
            },
            deactivateForm: '',
            lists: [],
            loadingLists: false,
            listDeployed: null,
            loadingListDeployed: false,
            newsletterActive: false,
            loading: false,
            //logs
            errorMsgPass: '',
            okLogPass: ''
        }
    },
    methods: {
        goBack(){
            if(this.loading) return;
            console.log("go back")
            if(this.view == 'edit')
                return this.view = 'profile';
            if(this.view == 'list'){
                this.listDeployed = null;
                return this.view = 'profile';
            }
            if(['changeEmail', 'changePass', 'deactivate', 'newsletter'].includes(this.view)) {
                this.changeEmailForm = '';
                this.changePassForm = { current: '', new: '', confirm: '' };
                this.deactivateForm = '';
                return this.view = 'edit';
            }
            if(this.view == 'profile') return this.$router.push('/');
        },

        getAuthHeaders() {
            return {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            };
        },

        onProfilePicChange(e) {
            const file = e.target.files[0];
            if (!file) return;
            this.selectedProfilePicFile = file;
            // Preview temporal
            this.form.profilepicPreview = URL.createObjectURL(file);
        },

        async saveProfile(){
            this.loading = true;
            try {
                const token = localStorage.getItem('token');

                const formData = new FormData();

                formData.append('name', this.form.name);
                formData.append('profession', this.form.profession || '');
                formData.append('instagram', this.form.instagram || '');

                if(this.selectedProfilePicFile) {
                    formData.append('profilepic', this.selectedProfilePicFile);
                }

                const response = await fetch(`${this.$ENDPOINT}/api/update_profile.php`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`
                    },
                    body: formData
                });
                const result = await response.json();

                console.log(result.message);

                if(result.status == 'success') {
                    localStorage.setItem('userData', JSON.stringify(result.user));

                    this.userData = result.user;
                    this.form.profilepic = result.user.profilepic;
                    this.form.profilepicPreview = '';
                    this.selectedProfilePicFile = null;

                    this.view = 'profile';
                }
            } catch(error) {
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        async changeEmail() {
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/change_email.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        email: this.changeEmailForm.email,
                        password: this.changeEmailForm.password
                    })
                });
                const result = await response.json();

                if(result.status == 'success') {
                    const userData = JSON.parse(localStorage.getItem('userData'));
                    userData.email = result.email;
                    localStorage.setItem('userData', JSON.stringify(userData));
                }

                this.goBack();
                console.log(result.message);
            } catch(error) {
                console.error(error);
            }
        },

        async changePass() {
            this.errorMsgPass = '';
            this.okLogPass = '';
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/change_password.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        current_password: this.changePassForm.current,
                        new_password: this.changePassForm.new,
                        confirm_password: this.changePassForm.confirm
                    })
                });
                const result = await response.json();

                console.log(result.message);
                const err = result.errors;
                if(err.current_password) this.errorMsgPass = err.current_password;
                if(err.confirm_password) this.errorMsgPass = err.confirm_password;
                if(err.new_password) this.errorMsgPass = err.new_password;
                
                // La API invalida la sesión automáticamente
                if(result.status == 'success') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('userData');
                    this.$router.push('/login');
                    this.errorMsgPass = '';
                    this.okLogPass = "Contraseña actualizada correctamente.";
                }
            } catch(error) {
                console.error(error);
            }
        },

        async deactivate() {
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/deactivate_account.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        password: this.deactivateForm
                    })
                });
                const result = await response.json();

                console.log(result.message);

                if(result.status == 'success') {
                    localStorage.removeItem('token');
                    localStorage.removeItem('userData');
                    this.$router.push('/');
                }
            } catch(error) {
                console.error(error);
            }
        },

        checkSession() {
            const token = localStorage.getItem('token');
            const userData = JSON.parse(localStorage.getItem('userData') || '{}');
            const onSession = !!token && !!userData.id;
            if(!onSession) this.$router.push('/');
        },

        openNewList() {
            this.newList = {
                active: true,
                name: '',
                error: false,
            };
        },

        closeNewList() {
            this.newList = {
                active: false,
                name: '',
                error: false,
            };
        },

        async fetchLists() {
            try {
                this.loadingLists = true;

                const response = await fetch(`${this.$ENDPOINT}/api/my-lists.php`, {
                    method: 'GET',
                    headers: this.getAuthHeaders()
                });

                const result = await response.json();

                if(result.status === 'success') {
                    this.lists = result.lists || [];
                } else {
                    console.log(result.message);
                }

            } catch(error) {
                console.error(error);
            } finally {
                this.loadingLists = false;
            }
        },

        async createList() {
            try {
                const name = this.newList.name;

                if(!name || name.trim() === '') {
                    this.newList.error = 'Campo requerido';
                    return;
                }

                const response = await fetch(`${this.$ENDPOINT}/api/create.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        name: name.trim(),
                        description: '',
                        visibility: 'private'
                    })
                });

                const result = await response.json();

                if(result.status === 'success') {
                    this.closeNewList();
                    await this.fetchLists();
                } else {
                    this.newList.error = result.message || 'No se pudo crear la lista';
                }

            } catch(error) {
                console.error(error);
                this.newList.error = 'Error de conexión';
            }
        },

        getListPreviewImages(list) {
            if(!list.preview_images) return [];
            return list.preview_images
                .filter(Boolean)
                .slice(0, 3)
                .map(file => `${this.$ENDPOINT}/assets/artworks/${file}`);
        },

        async deployList(id) {
            try {
                this.loadingListDeployed = true;
                this.view = 'list';

                const response = await fetch(`${this.$ENDPOINT}/api/list_detail.php?id=${encodeURIComponent(id)}`, {
                    method: 'GET',
                    headers: this.getAuthHeaders()
                });

                const result = await response.json();

                if(result.status === 'success') {
                    this.listDeployed = result;
                } else {
                    console.log(result.message);
                    this.listDeployed = null;
                }

            } catch(error) {
                console.error(error);
                this.listDeployed = null;
            } finally {
                this.loadingListDeployed = false;
            }
        },

        getEmptyPreviewAreas(list) {
            const imagesLength = this.getListPreviewImages(list).length;
            return ['A', 'B', 'C'].slice(imagesLength);
        },

        async checkNewsletterStatus(){
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/newsletter_status.php`, {
                    method: 'GET',
                    headers: this.getAuthHeaders()
                });

                const result = await response.json();

                if(result.status === 'success') {
                    this.newsletterActive = result.active;
                }

            } catch(error) {
                console.error(error);
            }
        },

        async toggleNewsletter(){
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/newsletter_toggle.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders(),
                    body: JSON.stringify({
                        active: this.newsletterActive
                    })
                });
                const result = await response.json();
                console.log(result.message);
            } catch(error) {
                console.error(error);
            }
        },

        async logOut(){
            try {
                const response = await fetch(`${this.$ENDPOINT}/api/logout.php`, {
                    method: 'POST',
                    headers: this.getAuthHeaders()
                });
                const result = await response.json();

                console.log(result.message);

                localStorage.removeItem('token');
                localStorage.removeItem('userData');

                this.$router.push('/');
            } catch(error) {
                console.error(error);

                localStorage.removeItem('token');
                localStorage.removeItem('userData');

                this.$router.push('/');
            }
        },
    },
    mounted() {
        this.form.name = this.userData.name || '';
        this.form.profession = this.userData.profession || '';
        this.form.instagram = this.userData.instagram || '';
        this.form.profilepic = this.userData.profilepic || '';

        this.checkSession();
        this.fetchLists();
        this.checkNewsletterStatus();
    }
}
</script>

<style scoped lang="stylus">
.SectionProfile-MAIN
    display: flex
    flex-direction: column
    padding: 10px
    width: calc(100% - 20px)
    min-height: calc(100vh - 20px)
    background-color: white

    >img
        width: 8vw
        margin-bottom: 2vw
        z-index: 1

    h2
        font-family: "Archivo ExtraCondensed", sans-serif
        text-transform: uppercase
        font-size: 8vw

    hr
        width: 100%
        border: 1px solid black

    /* inputs */
    b
        font-family: "Archivo ExtraCondensed", sans-serif
        font-size: 6.5vw
        text-transform: uppercase
        color: black

    input
        font-family: "Archivo ExtraCondensed", sans-serif
        padding: 2vw 0
        margin-bottom: 4vh
        border: none
        border-bottom: 1px solid black
        font-size: 5vw

        &::placeholder
            color: #C3C3C3
            font-size: 6vw

/* main */
.profile-main
    display: flex
    flex-direction: column
    height: fit-content
    max-height: calc(100vh - 20px - 6vw)
    overflow-y: auto
    overflow-x: hidden

    >div:first-child
        display: flex
        align-items: center
        justify-content: center
        padding: 5vh 0
        
        >img
            border: 1px solid lightgray
            border-radius: 100vw
            aspect-ratio: 1/1
            width: 50px
            margin-right: 10px

        >div
            >h2
                margin: 0

            >button
                font-family: "DM Mono", monospace
                font-size: 3vw
                color: white
                background-color: #015aff
                border: none
                padding: 5px 10px

    >h2
        margin-bottom: 0

    .saved-filters >button
        font-family: "DM Mono", monospace
        font-size: 3.5vw
        border-radius: 100vw
        border: none
        color: #707070
        background-color: white
        text-transform: uppercase
        padding: 3px 6px

    .btn-filter-selected
        color: white !important
        background-color: #015aff !important

    .saved-options
        display: flex
        align-items: center
        justify-content: space-between
        margin-top: 15px
        color: #707070
        font-family: "Archivo ExtraCondensed", sans-serif

    .profile-collections
        display: grid
        grid-template-columns: 1fr 1fr
        grid-gap: 10px
        margin-top: 10px
        //padding-bottom: calc(47px + 6vw)
        padding-bottom: 10px

        >p
            color: #707070
            text-align: center
            font-family: "DM Mono", monospace
            width: calc(100vw - 20px)
            font-size: 1.5ch
            margin-top: 50%

    .collection
        >div
            display: grid
            grid-template-areas: "A A" "B C"
            grid-template-columns: 1fr 1fr
            grid-template-rows: 1fr 1fr
            grid-gap: 3px
            width: 100%
            aspect-ratio: 1/1
            border-radius: 10px
            overflow: hidden
            margin-bottom: 5px

            >img
            >div
                width: 100%
                height: 100%
                object-fit: cover
                object-position: center
                min-width: 0
                min-height: 0

            .empty-preview
                background-color: lightgray

        >p
            margin: 0
            font-family: "Archivo ExtraCondensed", sans-serif

            &:nth-child(2)
                font-size: 6vw
                font-weight: 500

            &:nth-child(3)
                font-size: 4.4vw

        .empty-preview
            background-color: lightgray

/* edit */
.profile-edit
    display: flex
    flex-direction: column
    height: fit-content
    max-height: calc(100vh - 20px - 6vw - 47px) !important
    overflow-y: auto
    overflow-x: hidden
    margin-top: -33px

    >div
        display: flex
        flex-direction: column
        align-items: center
        justify-content: center
        margin-bottom: 25px

        >h3
            font-family: "Archivo ExtraCondensed", sans-serif
            text-transform: uppercase
            margin-top: 0

        >img
            width: 30vw
            aspect-ratio: 1/1
            object-fit: cover
            object-position: center
            border-radius: 100vw
            border: 1px solid lightgray
            margin-top: 0px
            margin-bottom: 15px

        >button
            font-family: "DM Mono", monospace
            font-size: 3vw
            border: none
            text-transform: uppercase
            color: white
            background-color: #707070
            padding: 5px 10px
            border-radius: 3px
            position: relative

            >input
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 100%
                opacity: 0

    .p-actions
        color: #707070
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100
        font-size: 4.4vw
        margin-top: 0
        text-decoration: underline

    .p-close-session
        color: red

    >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        border: none
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace

/* list */
.profile-list
    display: flex
    flex-direction: column
    justify-content: flex-end
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100vh
    background-color: rgba(0, 0, 0, 0.5)

    .close-list
        flex-grow: 1

    >div:not(.close-list)
        display: flex
        flex-direction: column
        background-color: white
        border-radius: 20px 20px 0 0
        padding: 20px
        min-height: 50%

        >input
            margin-top: 10px
            margin-bottom: 10px

        .input-list-error
            border-bottom: 1px solid red !important

        >p
            color: red
            font-family: "Archivo ExtraCondensed", sans-serif
            font-weight: 100
            font-size: 5vw
            margin: 0

        >button
            height: 47px
            background-color: #015aff
            color: white
            border: none
            border-radius: 100vw
            font-family: "DM Mono", monospace
            text-transform: uppercase

/* change email and pass + deactivate h3 and button */
.profile-change-email
.profile-change-pass
.profile-deactivate
.profile-edit-newsletter
    display: flex
    flex-direction: column
    height: fit-content
    max-height: calc(100vh - 20px - 6vw)
    overflow-y: auto
    overflow-x: hidden

    >h3
        font-family: "Archivo ExtraCondensed", sans-serif
        text-transform: uppercase
        margin-top: 0
        width: 100%
        text-align: center
        margin-bottom: 10vh

    >button
        height: 47px
        width: calc(180px + 18px + 18px)
        background-color: rgb(1, 90, 255)
        border: none
        color: white
        max-width: 75vw
        position: fixed
        margin: auto
        left: 0
        right: 0
        bottom: 6vw
        border-radius: 100vw
        z-index: 1
        font-family: "DM Mono", monospace

.profile-deactivate
.profile-edit-newsletter
    >p
        font-family: "Archivo ExtraCondensed", sans-serif
        margin-top: 0
        font-size: 6.6vw
        color: #707070
        margin-bottom: 8vh
        text-wrap: pretty

    >button:not(.profile-cancel-dectivate)
        bottom: calc(6vw + 47px + 10px)

    .profile-cancel-dectivate
        color: #707070
        background-color: white
        border: 1px solid #707070

/* switch */
.switch
    display: flex
    align-items: center
    font-family: "DM Mono", monospace

    >label
        margin-right: 15px

.news-switch
    height: 20px
    width: 40px
    background-color: var(--switch-bg)
    border-radius: 100vw
    display: flex
    align-items: center
    position: relative
    cursor: pointer
    background-color: gray

    input
        display: none

    >div
        width: 14px
        aspect-ratio: 1/1
        border-radius: 100vw
        background-color: white
        position: absolute
        left: 3px
        transition: left 0.1s, background-color 0.1s

    input:checked + div
        left: calc(100% - 14px - 3px)
        background-color: white

.news-switch:has(input:checked)
   background-color: #1E88E5

.news-switch-lock
    display: flex
    align-items: center
    justify-content: center

    >img
        max-height: 80%

/* deploy list */
.deploy-list
    height: calc(100vh - 20px - 6vw)
    overflow-y: auto

    >h2
        margin-bottom: 0

    >p
        margin: 0
        color: #707070
        font-family: "DM Mono", monospace
        font-size: 4vw

.list-item-grid
    display: grid
    grid-template-columns: 1fr 1fr
    grid-gap: 10px

    .list-item-img
        >img
            width: 100%
            border-radius: 5px

        >p
            font-family: "Archivo ExtraCondensed", sans-serif

/* error msg */
.error-msg
.ok-log
    color: rgb(1, 90, 255)
    font-family: "Archivo ExtraCondensed", sans-serif
    font-weight: 100
    font-size: 4.4vw
    margin-bottom: 0
    margin-top: 25px !important
    color: red !important  

.ok-log
    color: #015aff !important
</style>